/* eslint-disable no-unused-vars */
import React from 'react';
import { PageWrapStyles } from './pagewrapstyles';

import Header from '../header';
import MapCoal from '../map-coal';
import MapRenew from '../map-renew';
import Footer from '../footer';

export default function PageWrap({ project = 'coal' }) {
  const MapComponent = project === 'renewable' ? MapRenew : MapCoal;

  return (
    <PageWrapStyles>
      <Header project={project} />
      <MapComponent />
      <Footer />
    </PageWrapStyles>
  );
}
